import { Button, Icon } from '@monash/portal-react';
import { useWidgetContext } from '@/components/providers/WidgetProvider';
import noneSelected from './none-selected.svg';
import c from './none-selected.module.scss';

export const NoneSelected = ({ widgetId }) => {
  const { setEditActiveWidget } = useWidgetContext();

  return (
    <div className={c.wrapper}>
      <div className={c.innerWrapper}>
        <img src={noneSelected} alt="" width="162" height="90" />

        <b>No carparks selected</b>

        <Button
          variant="text"
          size="small"
          icon={<Icon.Pencil />}
          onClick={() => {
            setEditActiveWidget(widgetId);
          }}
          mode="card"
        >
          Add car park(s)
        </Button>
      </div>
    </div>
  );
};
